import { isStaging, cloudflareCDN } from "./utils";
import { firebaseHelper } from "./firebase";

/**
 * Base URL for Stripe processor cloud function
 */
const stripeProcessorURL = isStaging()
  ? "https://us-central1-mattoboard-staging.cloudfunctions.net/StripeProcessor5"
  : "https://us-east1-mattoboard-b8284.cloudfunctions.net/StripeProcessor5";

/**
 * Stripe publishable keys (environment-specific)
 */
export const publishableKey = isStaging()
  ? "pk_test_51M4werAMgAm8AkfpJ203wXJrgT22dTeadRv8LubM0CvnEgBJEe9KTbOfgOBbzHYQczwrBgXu7GMGSo4RSJFZcNm800ythAObmp"
  : "pk_live_51M4werAMgAm8Akfp1Yc4LmgpwqPQ8KzMPfOccVakXkZO836iy00WqzNkuaLacHXfNywtpxOj3LDpv1zhhMoZaia0000UhJjiED";

/**
 * API endpoint for fetching credit prices and location
 */
export const getCreditPricesAndLocationAPIUrl =
  stripeProcessorURL + "/getCreditPricesAndLocation";

/**
 * Returns a CDN-wrapped URL for the Stripe pitch image.
 */
export const getStripePitchImage = (
  size: string,
  imageNumber: 1 | 2 | 3 | 4 = 2,
): string => {
  const imageRef = `stripe_images/expert-pitch-spread--HALF-IMAGE-${imageNumber}.jpg`;
  const publicURL = firebaseHelper.URLFromRef(imageRef);
  return cloudflareCDN(publicURL, size);
};
